import {Backbone} from 'Vertebrae';
import {Role} from '../model/role';

export const Roles = Backbone.Collection.extend({
    _name : 'Roles',
    model : Role
});
